import { DealernetApi } from "./DealernetApi";

export const FEATURE_CONTROLLER_PATH = "FeatureFlag";
var enabledFeatures: Array<string> = [];

export class FeatureFlagService {

  // Do not call this function from various areas of the site. All feature flags are loaded during site authentication
  // Rather, use getFeatureEnabled() to check by feature name from const.js
  public static async GetFeatureFlags(featureNames, mcfCostCenterId = null, accountId = null){
    var params = {
      featureNames: featureNames,
      mcfCostCenterId: mcfCostCenterId,
      accountId: accountId
    };
    
    const response = await DealernetApi.client().post(
      `${FEATURE_CONTROLLER_PATH}/GetFeatureFlags`, params
    );
    
    let featureFlags = response.data;
    for(const featureFlag in featureFlags){
      if( featureFlags[featureFlag] === true ){
        enabledFeatures.push(featureFlag);
      }
    }
  } 

  public static getFeatureEnabled(featureName){
    return enabledFeatures.includes(featureName);
  }
}
